import request from '@/utils/request'

export function GetIndexVideoApi() {
    return request.post(
        process.env.VUE_APP_API_HOST + '/video/index',
        {},
        {}
    )
}
